import type {
  RolfsEvent,
  RolfsEventListItem,
  EventRegistrationResponse,
  RegisterForEventParams,
} from '@layers/web/services/types/event-api.ts'

export class EventApiService {
  static async fetchSingleEvent (slug: string): Promise<RolfsEvent[]> {
    const { market } = useRuntimeConfig().public
    const { data: res } = await apiFetch<RolfsEvent[]>(`/${market}/event/${slug}`)
    return res
  }

  static async fetchUpcomingEvents (): Promise<RolfsEventListItem[]> {
    const { market } = useRuntimeConfig().public
    const { data: result } = await apiFetch<RolfsEventListItem[]>(`/${market}/event-list`)
    return result
  }

  static async registerForEvent ({ id, email, name, pax }: RegisterForEventParams): Promise<EventRegistrationResponse | undefined> {
    const { market } = useRuntimeConfig().public

    try {
      const { data: result } = await apiFetch(`/${market}/event-register`, {
        method: 'POST',
        body: {
          event_id: id,
          email,
          name,
          number_pax: pax,
        },
      })

      return result
    } catch (error) {
      logFailedHttpRequest(error)
    }
  }
}
